import { useEffect, useRef, useState } from "react";
import { Image, Description, Menu, Icon, NavStyled, MenuResponsive, Container } from "./styles"
import array from "./array"

import menu from "../../assets/menu.png"
import foto from "../../assets/foto.png"


export default function Nav(props) {
  const navRef = useRef();
  const [showImgS, setShowImgS] = useState(true);
  const [showMenu, setShowMenu] = useState();
  const [hideMenuState, setHideMenuState] = useState(false);

  let widthPage

  useEffect(() => {
    resizePage()
  }, [])


  function resizePage(event) {
    if (navRef.current) {
      widthPage = Number(
        navRef.current.getBoundingClientRect().width.toFixed(0)
      );
    }


    if (widthPage <= 830) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }

  }

  function showAndHideMenu() {
    setHideMenuState(!hideMenuState);
  }

  function hideBoxMenu() {

    setHideMenuState(false)

  }




  window.addEventListener("resize", resizePage);

  window.addEventListener("scroll", () => {
    const topNav = navRef.current.getBoundingClientRect();

    if (topNav.top === 0) {
      setShowImgS(false);
    } else {
      setShowImgS(true);
    }
  });

  return !showMenu
    ?
    (
      <NavStyled ref={navRef}>
        {hideMenuState ? (
          <MenuResponsive hidemenu={hideMenuState.toString()}>

            <ul >
              {array.map(menu => <a href={menu.href} key={menu.name}>
                <li onClick={hideBoxMenu}>{menu.name}</li>
              </a>)}

            </ul>

            <Icon
              onClick={showAndHideMenu}
              src={menu}
              alt="menu"
            />
          </MenuResponsive>
        )
          :
          (
            <Icon
              onClick={showAndHideMenu}
              src={menu}
              alt="menu"
            />
          )}
      </NavStyled>
    )
    :
    (
      <Menu ref={navRef}>
        <ul >
          {
            array.map(menu => {
              if (["Inicio", "Sobre", "Serviços"].includes(menu.name)) {
                return (<a href={menu.href} key={menu.name}>
                  <li >{menu.name}</li>
                </a>)
              }
            }
            )
          }
        </ul>

        <Container>

          <Image
            showimg={showImgS.toString()}
            src={foto}
            alt="foto Wellington"
          />
          {/* vai ser ou a imagem ou a descriçao na barra do menu, esta tudo modificado na opacidade*/}

          <Description showimg={showImgS.toString()}>
            <h3>Wellington Eduardo</h3>
            <p>Desenvolvedor Full Stack</p>
          </Description>

        </Container>


        <ul >
          {
            array.map(menu => {

              if (["Qualificações", "Projetos", "Contatos"]
                .includes(menu.name)) {
                return (<a href={menu.href} key={menu.name}>
                  <li >{menu.name}</li>
                </a>)
              }
            }
            )
          }
        </ul>


      </Menu>
    );
}
